export function getLocations(entryId) {
	const query = `{
		entry (id: ${entryId}) {
			title
			... on properties_property_Entry {
				lat,
				lng,
				thingsToDo {
					id,
					title,
					... on thingsToDo_thingsToDo_Entry {
						map { lat, lng }
						thingsToDoCategory {
							id,
							title,
							... on thingsToDo_Category {
								marker { url }
							}
						}
					}
				}
			}
		}
	}`;

	function executeQuery() {
		const body = JSON.stringify({
			query: query,
			[window.csrfTokenName]: window.csrfTokenValue,
		});

		return fetch('/api', {
			body: body,
			method: 'post',
			headers: { 'Content-Type': 'application/json' },
		})
			.then(response => response.json())
			.then(json => processResults(json));
	}


	function processResults(json) {
		let entries = json.data.entry.thingsToDo;

		let locations = entries.map(entry => {
			let icon;

			try {
				icon = entry.thingsToDoCategory[0].marker[0].url;
			} catch (e) {
				icon = '/assets/icons/markers/default.svg';
			}

			return {
				id: entry.id,
				title: entry.title,
				lat: entry.map.lat,
				lng: entry.map.lng,
				categories: entry.thingsToDoCategory,
				icon: icon,
			};
		});

		return {
			lat: Number(json.data.entry.lat),
			lng: Number(json.data.entry.lng),
			title: String(json.data.entry.title),
			locations,
		};
	}

	return executeQuery();
}
